import { render, staticRenderFns } from "./ResultTopicClover.vue?vue&type=template&id=0ecb5342"
import script from "./ResultTopicClover.vue?vue&type=script&lang=js"
export * from "./ResultTopicClover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports